export default class Constants {
	static SURVEY_ID_DSG = 5452;
	static SURVEY_ID_GG = 5462;
	static SURVEY_ID_PL = 7170;
	static TEXT_CHAR_LIMIT = 15;
	static CALL_STORE_MINUTE_THRESHOLD = 8;

	static TITLE_DICKS_SPORTING_GOODS = 'Dick\'s Sporting Goods';
	static TITLE_GOLF_GALAXY = 'Golf Galaxy';
	static TITLE_PUBLIC_LANDS = 'Public Lands';

	static CHAIN_DICKS_SPORTING_GOODS = 'DICKS SPORTING GOODS';
	static CHAIN_GOLF_GALAXY = 'GOLF GALAXY';
	static CHAIN_PUBLIC_LANDS = 'PUBLIC LANDS';
	static COOKIE_GOLF_GALAXY = 'GG';
	static COOKIE_PUBLIC_LANDS = 'PL';

	static CHECK_IN_CURBSIDE = 'curbside';
	static CHECK_IN_CURBSIDE_TITLE = 'Curbside Check In';
	static CHECK_IN_CURBSIDE_CONTENT_TITLE = 'Describe Your Ride';
	static CHECK_IN_CURBSIDE_BUTTON_TEXT = 'I\'m Curbside';
	static CHECK_IN_CURBSIDE_TYPE_TEXTFIELD_LABELS = {
        label: 'Description of Vehicle Type',
        placeholder: 'Please describe your vehicle type',
        errorHelperText: 'Vehicle Description can\'t be empty!'
    };
	static CHECK_IN_CURBSIDE_COLOR_TEXTFIELD_LABELS = {
        label: 'Color of Vehicle',
        placeholder: 'Please describe your vehicle color',
        errorHelperText: 'Vehicle color can\'t be empty!'
    };
	static CHECK_IN_CURBSIDE_PARKING_OTHER_TEXTFIELD_LABELS = {
        label: 'Your Current Location',
        placeholder: 'Please describe your current location',
        errorHelperText: 'Current location can\'t be empty!'
    };
	static CHECK_IN_CURBSIDE_PARKING_SPOT_TEXTFIELD_LABELS = {
        label: 'Your Spot Number',
        placeholder: 'Please enter your spot number',
        errorHelperText: 'Spot number can\'t be empty!'
    }

	static CHECK_IN_STORE = 'instore';
	static CHECK_IN_STORE_TITLE = 'In Store Check In';
	static CHECK_IN_STORE_CONTENT_TITLE = 'Help us find you';
	static CHECK_IN_STORE_BUTTON_TEXT = 'I\'m In Store';
    static CHECK_IN_STORE_TYPE_TEXTFIELD_LABELS = {
        label: 'Other Article of Clothing',
        placeholder: 'Other article of clothing',
        errorHelperText: 'Clothing type can\'t be empty!'
    };
    static CHECK_IN_STORE_COLOR_TEXTFIELD_LABELS = {
        label: 'Clothing Color',
        placeholder: 'Please describe your clothing color',
        errorHelperText: 'Clothing color can\'t be empty!'
    };
    static CHECK_IN_STORE_LOCATION_TEXTFIELD_LABELS = {
        label: 'In Store Location',
        placeholder: 'Please describe your in store location',
        errorHelperText: 'In store location can\'t be empty!'
    };

	static CHECK_IN_RESULT_SUCCESS = 'success';
	static CHECK_IN_RESULT_SUCCESS_TITLE = 'Checked In';
	static CHECK_IN_RESULT_CLOSED = 'closed';
	static CHECK_IN_RESULT_CLOSED_TITLE = 'Fumble';
	static CHECK_IN_RESULT_FAILED = 'failed'
	static CHECK_IN_RESULT_FAILED_TITLE = 'Fumble'

	static DEFAULT_TITLE = "Order Pickup";
	static PICKED_UP_TITLE = "Picked Up";
	static EXTENDED_TITLE = "Pickup Extended";
	static EXPIRED_TITLE = "Pickup Expired";

	static DEFAULT_MESSAGE = "After you arrive at the store, select curbside or in-store pickup and describe your vehicle or clothing.";
	static DEFAULT_MESSAGE_MULTI = "Your order has pickup items at multiple stores. Which store are you picking up from now?";

	static ERROR_FALLBACK_DSG = "Air ball";
	static ERROR_FALLBACK_GG = "Unplayable";
	static ERROR_FALLBACK_PL = "Off Trail";
	static ERROR_FALLBACK_MESSAGE_DSG = "Your order information missed the basket. We’re sorry, please try again. If the problem persists, please let us know.";
	static ERROR_FALLBACK_MESSAGE_GG = "Your order information veered off-course. We’re sorry, please try again. If the problem persists, please let us know.";
	static ERROR_FALLBACK_MESSAGE_PL = "Your order information has veered off the trail. We’re sorry, please try again. If the problem persists, please let us know.";
	static ERROR_EXPIRED_MESSAGE_DSG = "We’re sorry, the shot clock ran out on this offer and your pickup was cancelled. The gear you wanted may still be available for curbside pickup at another store near you.";
	static ERROR_EXPIRED_MESSAGE_GG = "We’re sorry, the timing on this order was over par and your pickup was cancelled. The gear you wanted may still be available for curbside pickup at another store near you.";
	static ERROR_EXPIRED_MESSAGE_PL = "We’re sorry, the sun set on this offer and your order has been cancelled. The gear you wanted may still be available for curbside pickup at another store near you.";

	static STATUS_FOUND = 'found';
	static STATUS_READY = 'ready';
	static STATUS_PICKED_UP = 'picked up';
	static STATUS_EXTENDED = 'extended';
	static STATUS_CANCELED = 'canceled';

	static STORE_STATUS_CLOSED = 'closed';
	static STORE_STATUS_OPEN = 'open';
	static STORE_STATUS_CURBSIDE = 'curbside';
	static STORE_STATUS_IN_STORE = 'instore';

	static STORE_STATUS_CLOSED_TITLE = 'Delay of Game';

	static STORE_OPEN_DEFAULT_MSG = 'Open for pickup until';
	static STORE_OPEN_IN_STORE_MSG_1 = 'Open for in store pickup until';
	static STORE_OPEN_IN_STORE_MSG_2 = 'Open for in store pickup at';
	static STORE_OPEN_CURBSIDE_MSG_1 = 'Open for curbside pickup until';
	static STORE_OPEN_CURBSIDE_MSG_2 = 'Open for curbside pickup at';
}
